module.exports = __webpack_public_path__ + "static/media/Dev2.b54e26bb.png";